export enum LocaleTypeEnum {
  CS = "cs",
  SK = "sk",
  EN = "en",
  UA = "uk",
}
